import {DialogFragment, PageFragment, PageFragmentProps} from "@/shared/PageFragment";
import {Box} from "@mui/material";
import {FormGenContainer, FormGenContainerMode} from "@/shared/FormGenContainer";
import {DW_LG} from "@/shared/dimens";
import {BaseApp, DIALOG_FLAG_DISABLE_BACKDROP_CLICK, DIALOG_FLAG_SHOW_CLOSE} from "@/shared/BaseApp";
import React from "react";
import {LabelerDataset, ResourceData} from "@/fyneai-shared/types";

export class EditDatasetHelper {

  static addDataset() {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditLabelerDatasetFragment onLabelerDatasetSaved={dataset => BaseApp.CONTEXT.hideDialog()}/>);
  }

  static editDataset(dataset: LabelerDataset) {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditLabelerDatasetFragment edit={dataset} onLabelerDatasetSaved={dataset => BaseApp.CONTEXT.hideDialog()}/>);
  }
}

type EditLabelerDatasetFragmentProps = PageFragmentProps & {
  edit?: LabelerDataset,
  onLabelerDatasetSaved: (dataset: LabelerDataset) => void,
}

class EditLabelerDatasetFragment extends DialogFragment<EditLabelerDatasetFragmentProps> {

  private readonly labelerDatasets = ResourceData.project().labeler.datasets;
  private readonly labelerDataset = this.props.edit ? this.props.edit : LabelerDataset.createNew();

  protected onCreateState() {
    return {
      ...super.onCreateState(),
      title: this.props.edit ? "Edit" : "Add",
    };
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_ACTION_PANEL_TYPE_BUTTON_FLAG;
  }

  protected getActionButtonText(): string {
    return this.props.edit ? "Save" : "Add";
  }

  onActionButtonClicked() {
    this.addLabelerDataset().then(() => this.props.onLabelerDatasetSaved(this.labelerDataset));
  }

  private async addLabelerDataset() {
    await this.labelerDatasets.addListItem(this.labelerDataset);
  }

  renderContent(): React.ReactElement | null {
    return <Box style={{display: "flex", width: DW_LG}}>
      <FormGenContainer
        mode={this.props.edit ? FormGenContainerMode.EDIT : FormGenContainerMode.CREATE}
        content={this.labelerDataset}
        saveActionButtonProvider={this}/>
    </Box>;
  }
}
